const TESTING_ACCEPT_STATUS = {
  field: {
    temp: 0,
    join: 1,
    decided: 2,
    confirmed: 3,
    checking: 4,
    completed: 5,
    delayed: 6,
    canceled: 7,
    refundJoin: 8,
    refunded: 9,
  },
  value: [
    1, // join
    2, // decided
    3, // confirmed
    4, // checking
    5, // completed
    6, // delayed
    7, // canceled
    8, // refundJoin
    9, // refunded
  ],
  used: [1, 2, 3, 4, 5],
  unused: [0, 6, 7, 8, 9],
  name: {
    0: '삭제대기',
    1: '접수신청',
    2: '접수 및 결제완료',
    3: '접수완료',
    4: '시험완료',
    5: '결과확인',
    6: '시험연기',
    7: '취소 및 환불완료',
    8: '환불신청',
    9: '환불완료',
  },
  moktest: {
    0: '삭제대기',
    1: '접수신청',
    2: '접수 및 결제완료',
    3: '시험진행중',
    4: '시험완료',
    5: '결과확인',
    6: '시험연기',
    7: '취소 및 환불완료',
    8: '환불신청',
    9: '환불완료',
  },
  bank: {
    0: '삭제대기',
    1: '접수신청',
    2: '결제완료',
    3: '접수완료',
    4: '시험완료',
    5: '결과확인',
    6: '시험연기',
    7: '입금전취소',
    8: '환불신청',
    9: '환불완료',
  },
};

module.exports = TESTING_ACCEPT_STATUS;